import { NavLink, Outlet } from 'react-router'

import { cn } from '@/lib/cn'
import { Card } from '@/components/ui/Card'

interface SettingsTab {
  label: string
  to: string
}

/**
 * Fanerne under Indstillinger.
 *
 * Alle vises for alle. Siderne bag dem er læsbare uden administratorrettigheder
 * og deaktiverer selv det, man ikke må ændre — en fane, der forsvandt for nogle
 * brugere, ville se ud som om noget var gået i stykker.
 */
const TABS: SettingsTab[] = [
  { label: 'Profil', to: '/app/settings/profile' },
  { label: 'Sikkerhed', to: '/app/settings/security' },
  { label: 'Notifikationer', to: '/app/settings/notifikationer' },
  { label: 'Organisation', to: '/app/settings/organization' },
  { label: 'Moduler', to: '/app/settings/moduler' },
  { label: 'Medlemmer', to: '/app/settings/members' },
]

/**
 * Ramme om indstillingssiderne.
 *
 * Ligger som rute-layout og ikke som en komponent, hver side selv indsætter.
 * Siderne har forskellig bredde — medlemslisten fylder hele fladen, resten er
 * smalle — og en fælles fanerække er det eneste, de skal dele.
 *
 * Uden den var Organisation og Moduler kun tilgængelige ved at skrive stien
 * ind i adresselinjen: intet i menuen pegede derhen.
 */
export function SettingsLayout() {
  return (
    <div className="flex flex-col gap-5">
      <Card as="panel" className="overflow-x-auto p-1">
        <nav aria-label="Indstillinger">
          <ul className="flex min-w-max gap-1">
            {TABS.map((tab) => (
              <li key={tab.to}>
                <NavLink
                  to={tab.to}
                  className={({ isActive }) =>
                    cn(
                      'block rounded-lg px-4 py-2 text-[13px] font-medium transition-colors',
                      'focus-visible:outline-2 focus-visible:outline-brand-400',
                      isActive
                        ? 'bg-brand-500/20 text-text-primary'
                        : 'text-text-secondary hover:bg-overlay-soft',
                    )
                  }
                >
                  {tab.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </Card>

      <Outlet />
    </div>
  )
}
